import React from 'react';
import PropTypes from 'prop-types';
import {
  PanResponder,
  View,
} from 'react-native';
import { ViewPropTypes } from 'deprecated-react-native-prop-types'

// import { throttle } from '../../modules/Utils';

class Slider extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.onMove = this.onMove.bind(this);
    this.onEndMove = this.onEndMove.bind(this);
    // throttle does not work here as it could not accumulate deltas
    // this.onMoveThrottled = (param) => throttle(this.onMove, JSON.parse(JSON.stringify(param)), 150);

    const { initialValue } = this.props;

    this.state = {
      barHeight: null,
      deltaValue: 0,
      value: initialValue,
    };

    this.panResponder = PanResponder.create({
      onMoveShouldSetPanResponderCapture: () => true,
      onPanResponderMove: (_, gestureState) => this.onMove(gestureState),
      onPanResponderRelease: () => this.onEndMove(),
      onPanResponderTerminate: () => { },
    });
  }

  onMove(gestureState) {
    const { min, max, horizontal } = this.props;
    const { barHeight } = this.state;

    const newDeltaValue = this.getValueFromBottomOffset(
      horizontal ? gestureState.dx : -gestureState.dy,
      barHeight,
      min,
      max
    );

    this.setState({
      deltaValue: newDeltaValue,
    });
  }

  onEndMove() {
    const { min, max, onValueChange } = this.props;
    const { value, deltaValue } = this.state;

    const newValue = this.capValueWithinRange(value + deltaValue, [
      min,
      max,
    ]);

    this.setState({ value: newValue, deltaValue: 0 });
    onValueChange(newValue);
  }

  onBarLayout = (event) => {
    const { horizontal } = this.props;

    if (horizontal) {
      const { width: barHeight } = event.nativeEvent.layout;
      this.setState({ barHeight });
      return;
    }
    const { height: barHeight } = event.nativeEvent.layout;
    this.setState({ barHeight });
  };

  capValueWithinRange = (value, range) => {
    if (value < range[0]) return range[0];
    if (value > range[1]) return range[1];
    return value;
  };

  getValueFromBottomOffset = (
    offset,
    barHeight,
    rangeMin,
    rangeMax
  ) => {
    if (barHeight === null) return 0;
    return ((rangeMax - rangeMin) * offset) / barHeight;
  };

  getBottomOffsetFromValue = (
    value,
    rangeMin,
    rangeMax,
    barHeight
  ) => {
    if (barHeight === null) return 0;
    const valueOffset = value - rangeMin;
    const totalRange = rangeMax - rangeMin;
    const percentage = valueOffset / totalRange;
    return barHeight * percentage;
  };

  render() {
    const {
      margin,
      barWidth,
      circleDiameter,
      min,
      max,
      minColor,
      maxColor,
      style,
      horizontal,
    } = this.props;

    const { value, deltaValue, barHeight } = this.state;

    const cappedValue = this.capValueWithinRange(value + deltaValue, [
      min,
      max,
    ]);
    const bottomOffset = this.getBottomOffsetFromValue(
      cappedValue,
      min,
      max,
      barHeight
    );
    const bottomStart = this.getBottomOffsetFromValue(
      min,
      min,
      max,
      barHeight
    );

    return (
      <View
        style={[{
        }, horizontal ? {
          flex: 1,
          flexDirection: 'row',
          width: '100%',
          alignSelf: 'stretch',
          justifyContent: 'center',
        } : {
          flexGrow: 1,
          alignSelf: 'stretch',
          alignItems: 'center',
        }, style]}
      >
        <View
          style={[{
          }, horizontal ? {
            width: '60%',
            alignSelf: 'stretch',
            alignItems: 'center',
            flexDirection: 'column',
          } : {
            flexGrow: 1,
            alignSelf: 'stretch',
            justifyContent: 'center',
            flexDirection: 'row',
          }]}
        >
          <View
            style={[{
            }, horizontal ? {
              width: '100%',
              marginVertical: margin,
              alignItems: 'center',
              justifyContent: 'center',
              paddingHorizontal: circleDiameter / 2,
              height: circleDiameter,
            } : {
              width: circleDiameter,
              alignItems: 'center',
              paddingVertical: circleDiameter / 2,
              marginHorizontal: margin,
            }]}
          >
            <View
              style={[{
                backgroundColor: maxColor,
              }, horizontal ? {
                width: '100%',
                height: barWidth,
              } : {
                flexGrow: 1,
                width: barWidth,
              }]}
              onLayout={this.onBarLayout}
            />
            <View
              style={[{
                backgroundColor: minColor,
                position: 'absolute',
              }, horizontal ? {
                height: barWidth,
                width: bottomOffset - bottomStart,
                left: bottomStart + circleDiameter / 2,
              } : {
                width: barWidth,
                height: bottomOffset - bottomStart,
                bottom: bottomStart,
              }]}
            />
            <View
              style={[{
                borderWidth: 1,
                borderColor: 'gray',
                borderRadius: circleDiameter / 2,
                width: circleDiameter,
                height: circleDiameter,
                backgroundColor: 'white',
                position: 'absolute',
              }, horizontal ? {
                left: bottomOffset,
              } : {
                bottom: bottomOffset,
              }]}
              {...this.panResponder.panHandlers /* eslint-disable-line react/jsx-props-no-spreading */}
            />
          </View>
        </View>
      </View>
    );
  }
}

Slider.defaultProps = {
  margin: 20,
  barWidth: 2,
  circleDiameter: 16,
  initialValue: 0,
  min: 0,
  max: 100,
  minColor: 'red',
  maxColor: 'green',
  style: {},
  horizontal: false,
};

Slider.propTypes = {
  margin: PropTypes.number,
  barWidth: PropTypes.number,
  circleDiameter: PropTypes.number,
  initialValue: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  minColor: PropTypes.string,
  maxColor: PropTypes.string,
  style: ViewPropTypes.style,
  onValueChange: PropTypes.func.isRequired,
  horizontal: PropTypes.bool,
};

export default Slider;
